<template>
  <Card dis-hover>
    <packageTable
      tableName="devicelist"
      ref="contentBaseRef"
      class="contentBaseRef packageTable"
      :columnsData="columnsheader"
      :tableData="tableDataList"
      :reduceheight="reduceheight"
      :loading="tableLoading"
      :border="false"
      :tabletotallen="getPageTotal"
      :showSearchBtn="false"
      :tablePageSize="reqBase.page_size"
      @pageonChange="pageonChange"
      @pageSizeChange="pageSizeChange"
      @refreshBtn="init"
      @getSelect="didSelectChange"
      :showTableHeader="true"
    >
      <!-- 长显的search条件 -->
      <template slot="search">
        <Col span="6">
          <FormItem :label="this.$t('devicelist.region')">
            <Select v-model="form_filter.country_code" filterable>
              <Option
                v-for="(item, i) in statusData3"
                :key="i"
                :value="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="this.$t('devicelist.devicestatus')">
            <Select
              v-model="form_filter.status"
              filterable
              :placeholder="this.$t('devicelist.devicestatus')"
            >
              <Option
                v-for="(item, i) in statusData"
                :key="i"
                :value="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="this.$t('devicelist.deviceallocationstatus')">
            <Select
              v-model="form_filter.fp_status"
              filterable
              :placeholder="this.$t('devicelist.deviceallocationstatus')"
            >
              <Option
                v-for="(item, i) in statusData2"
                :key="i"
                :value="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>

        <Col span="6">
          <FormItem :label="this.$t('devicelist.modelcode')">
            <Input
              type="text"
              v-model="form_filter.model_code"
              :placeholder="this.$t('devicelist.modelcode')"
            />
          </FormItem>
        </Col>

        <Col span="6">
          <FormItem :label="this.$t('devicelist.did')">
            <Input
              type="text"
              v-model="form_filter.did"
              :placeholder="this.$t('devicelist.did')"
            />
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="bms_sn">
            <Input
              type="text"
              v-model="form_filter.bms_sn"
              :placeholder="this.$t('devicelist.bms_sn')"
            />
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="pack_sn">
            <Input
              type="text"
              v-model="form_filter.pack_sn"
              :placeholder="this.$t('devicelist.pack_sn')"
            />
          </FormItem>
        </Col>
      </template>
      <!--收起的查询条件-->
      <template slot="searchMore">
        <Col span="6">
          <FormItem label="SN">
            <Input type="text" v-model="form_filter.sn" placeholder="SN" />
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="this.$t('devicelist.agent')">
            <Cascader
              :data="merchantData"
              change-on-select
              v-model="form_filter.merchant_code"
              transfer
              :placeholder="this.$t('devicelist.selectagent')"
              filterable
            ></Cascader>
          </FormItem>
        </Col>

        <Col span="6">
          <FormItem :label="this.$t('devicelist.projectnum')">
            <Input
              type="text"
              v-model="form_filter.project_id"
              :placeholder="this.$t('devicelist.projectnum')"
            />
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="this.$t('devicelist.hardwareversion')">
            <Input
              type="text"
              v-model="form_filter.hw_ver"
              :placeholder="this.$t('devicelist.hardwareversion')"
            />
          </FormItem>
        </Col>

        <Col span="6">
          <FormItem :label="this.$t('devicelist.softwareversion')">
            <Input
              type="text"
              v-model="form_filter.sw_ver"
              :placeholder="this.$t('devicelist.softwareversion')"
            />
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="this.$t('devicelist.passageway')">
            <Select
              v-model="form_filter.sw_channel"
              filterable
              :placeholder="this.$t('devicelist.passageway')"
            >
              <Option
                v-for="(item, i) in statusData0"
                :key="i"
                :value="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
      </template>
      <!-- 需要点击search按钮显示的search条件 -->
      <template slot="searchOperation">
        <Col span="6">
          <Button
            v-for="(item, index) in topButtonList"
            :type="item.type"
            style="margin-right: 5px"
            :icon="item.icon"
            @click="item.method"
            :key="index"
            >{{ item.name }}</Button
          >
        </Col>
      </template>

      <template slot="headLeft">
        <Tooltip
          v-for="(item, index) in topButtonList1"
          transfer
          :key="index"
          :content="item.name"
          placement="bottom"
        >
          <Button
            :type="item.type"
            style="margin-right: 5px"
            @click="item.method"
            :key="index"
            :icon="item.icon"
          ></Button>
        </Tooltip>
      </template>
    </packageTable>
    <Modal
      v-model="showImg"
      :width="800"
      transfer
      closable
      :footer-hide="true"
      :title="$t('viewLargeImg')"
    >
      <img style="width: 100%; height: auto" :src="showImgUrl" />
    </Modal>
    <Modal
      v-model="showImg1"
      :width="600"
      :footer-hide="false"
      title="提示"
      @on-ok="okData"
    >
      <p>{{ dataText }},是否重新进行分配</p>
      <i-table
        tableName="devicelist1"
        border
        :columns="columns1"
        :data="dataValue"
      ></i-table>
    </Modal>
  </Card>
</template>
<script>
import packageTableMixins from "@/mixins/packageTableMixins";
import addAppCustom from "./components/addAppCustom";
import downloadCustom from "./components/downloadCustom";
import customDetails from "./components/customDetails.vue";
import downloadHistory from "./components/downloadHistory.vue";
import config from "@/config/index";
import passCom from "./components/passCom";

import {
  device_distribution_list,
  get_downloadtoken,
  allocation_add,
  allocation_del,
  export_success_did,
  get_merchant_all,
  quxiao_fenpei,
  did_config_pass,
} from "@/api/jingxiaoshang";
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data() {
    return {
      formModelGlobe: null,
      formData1: null,
      dataValue: [],
      dataText: null,
      showImg: false,
      showImg1: false,
      showImgUrl: null,
      pass_priv: 1,
      dids: [],
      merchantData: [],
      statusData0: [
        { value: 0, name: this.$t("通道0") },
        { value: 1, name: this.$t("通道1") },
      ],
      statusData: [
        { value: -1, name: this.$t("全部") },
        { value: 2, name: this.$t("devicelist.online") },
        { value: 1, name: this.$t("devicelist.offline") },
      ],
      statusData2: [
        { value: -1, name: this.$t("全部") },
        { value: 1, name: this.$t("已分配") },
        { value: 2, name: this.$t("未分配") },
      ],
      statusData3: [
        { value: "xciot-prod-cnsz", name: this.$t("Changelang.中国") },
        { value: "xciot-prod-hk", name: this.$t("Changelang.香港") },
        { value: "xciot-prod-us2", name: this.$t("美国") },
        { value: "xciot-prod-eu", name: this.$t("Changelang.欧洲") },
      ],
      device_typeData: [
        { value: "-1", name: "全部" },
        { value: "1", name: "家储" },
        { value: "2", name: "基站" },
        { value: "3", name: "高压" },
        { value: "4", name: "PCS" },
        { value: "5", name: "其他" },
      ],
      form_filter: {
        project_id: null,
        hw_ver: null,
        sw_ver: null,
        model_code: null,
        sw_channel: 1,
        sw_ver: null,
        status: null,
        fp_status: null,
        po: null,
        sn: null,
        country_code: "xciot-prod-cnsz",
      },
      //共用的查询与重置
      topButtonList: [
        {
          name: this.$t("query"),
          type: "primary",
          icon: "ios-search",
          method: this.search,
        },
        {
          name: this.$t("reset"),
          type: "error",
          icon: "ios-refresh",
          method: this.reset,
        },
      ],
      // //共用的右侧添加按钮
      topButtonList1: [
        {
          name: this.$t("导出产测成功设备id"),
          icon: "ios-cloud-download",
          type: "primary",
          method: this.exportsuccess,
        },
        // {
        //   name:'导入',
        //   icon:'ios-cloud-upload',
        //   type:'primary',
        //   method:this.add
        // },
        {
          name: this.$t("批量分配"),
          icon: "ios-hand",
          type: "primary",
          method: this.pl_distribution,
        },
      ],
      reqBase: {
        page: 1,
        page_size: 15,
      },
      status: true, //是否企业认证
      tableDataList: [],
      getPageTotal: 0,
      operationButtonList: [
        // {
        //   name:this.$t('devicelist.exporthistory'),
        //   type:'text',
        //   icon:'',
        //   method:this.export
        // },
        // {
        //   name:this.$t('devicelist.control'),
        //   type:'text',
        //   icon:'',
        //   method:this.control
        // },
        // {
        //   name:this.$t('devicelist.see'),
        //   type:'text',
        //   icon:'',
        //   method:this.details
        // },
        // {
        //   name:this.$t('devicelist.viewtrajectory'),
        //   type:'text',
        //   icon:'',
        //   method:this.trajectory
        // },
        {
          name: this.$t("devicelist.distribution"),
          type: "text",
          icon: "",
          method: this.distribution,
        },
        {
          name: this.$t("devicelist.canceldistribution"),
          type: "text",
          icon: "",
          method: this.quxiao_distribution,
        },

        // {
        //   name:this.$t('devicelist.alarmlog'),
        //   type:'text',
        //   icon:'',
        //   method:this.alarmlog
        // },
        // {
        //   name:this.$t('devicelist.historylog'),
        //   type:'text',
        //   icon:'',
        //   method:this.historylog
        // },
        // {
        //           name:this.$t('devicelist.passman'),
        //           type:'text',
        //           icon:'',
        //           method:this.configpass
        // }
        // {
        //   name:'删除',
        //   type:'text',
        //   icon:'',
        //   method:this.del
        // },
      ],
      // operationButtonList1:[
      //   {
      //     name:this.$t('operationModule.submitReview'),
      //     type:'primary',
      //     icon:'',
      //     method:this.submitReview
      //   },
      // ],
      columnsheader: [],
      columns1: [
        {
          title: "设备ID",
          key: "did",
          align: "center",
          tree: true,
        },
        {
          title: "代理商",
          key: "shop_name",
          align: "center",
          tree: true,
        },
      ],
    };
  },
  props: {
    reducehe: {},
    code: {},
  },
  components: {
    customDetails,
  },
  computed: {
    userInfoStore() {
      let data = this.$store.state.user.userInfo;
      return data;
    },
  },
  methods: {
    alarmlog(row) {
      const routeData = this.$router.push({
        path: "/alarmManage/alermDes",
        query: { did: row.did },
      });
      window.open(routeData.href, "_self");
      // const routeData = this.$router.push({ path: '/deviceman/details', query: { did: row.did }})
      //   window.open(routeData.href, '_self')
    },
    historylog(row) {
      const routeData = this.$router.push({
        path: "/deviceman/distributionLog",
        query: { did: row.did },
      });
      window.open(routeData.href, "_self");
    },
    // mechanHome(row){
    //   window.open(config.webLinkUrl+'/index/'+row.company_code)
    // },
    // pageSizeChange(){

    // },
    getUser() {
      return this.$store.state.user.userInfo;
    },
    configpass(row) {
      let vm = this;
      let config = {
        loading: true,
        width: 500,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "5px" } },
                  this.$t("devicelist.passman")
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer",
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove();
                    },
                  },
                }),
              ]
            ),
            h("Divider", {
              style: {
                margin: "8px 0",
              },
            }),
            h(passCom, {
              ref: "passCom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: true,
                parent_code: "0",
                parent_name: "无",
                setData: row,
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.passCom;
          obj.checkForm().then((res) => {
            // console.log("req", {...obj.formModel})
            // return;
            if (res) {
              did_config_pass({ ...obj.formModel}).then((res) => {
                let msg = res.errorMsg;
                if (res.result === 0) {
                  let msg = res.errorMsg;
                  vm.$Message.success(msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },

    //导出产测成功设备
    exportsuccess(row) {
      let vm = this;
      let config = {
        loading: true,
        width: 600,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "15px" } },
                  this.$t("导出产测成功设备")
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer",
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove();
                    },
                  },
                }),
              ]
            ),
            h(downloadCustom, {
              ref: "downloadCustom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: true,
                projectCode: this.code,
                dids: this.dids,
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.downloadCustom;
          obj.checkForm().then((req) => {
            if (req) {
              let formModel = obj.formModel;
              //提交请求
              let domain = vm.get_domain();
              get_downloadtoken().then((res) => {
                // console.log(res.result)
                //     return
                _this.buttonLoading = false;
                if (res.result === 0) {
                  let downloadtoken = res.body.downloadtoken;
                  let params =
                    "?type=1&model_code=" +
                    formModel.model_code +
                    "&start_time=" +
                    formModel.start_time +
                    "&end_time=" +
                    formModel.end_time +
                    "&downloadtoken=" +
                    downloadtoken;

                  window.open(
                    domain +
                      "/index.php/admin/devicedetail/export_success_did" +
                      params
                  );
                  _this.$Modal.remove();
                } else {
                  _this.$Message.error(res.errorMsg);
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    /**
     * 导入sn
     */
    exportsuccess2() {
      let vm = this;
      let model_code_list = vm.getModelCode;
      let config = {
        loading: true,
        width: 600,
        render: (h) => {
          return h("div", [
            h("h3", this.$t("common.importsn")),
            h(uploadsnCom, {
              ref: "uploadsnCom",
              props: {
                edit: false,
                _vm: vm,
                model_code_list: model_code_list,
                model_code: this.form_filter.model_code,
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.uploadsnCom;
          obj.checkForm().then((res) => {
            if (res) {
              //提交请求
              let formModel = obj.formModel;
              let formData = new FormData();
              formData.append("filename", formModel.filename);
              formData.append("model_code", formModel.model_code);
              import_sn(formData).then((res) => {
                if (res.result === 0) {
                  vm.$Message.success({
                    content: res.errorMsg,
                    duration: 10,
                    closable: true,
                  });
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg, 5);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    //导出历史数据记录
    // export(row) {
    //   let vm = this
    //   let config = {
    //     title: "导出",
    //     loading: true,
    //     content: "您确定要导出当前数据吗？",
    //     onOk: function () {
    //       let _this = this

    //         get_downloadtoken().then(res => {
    //            _this.buttonLoading = false
    //            if (res.result === 0) {

    //             let downloadtoken = res.body.downloadtoken
    //             let params =
    //               "?type=1&downloadtoken=" +
    //                downloadtoken +"&did="+row.did

    //             window.open("http://pcphp.test.xcthings.com/index.php/admin/device/history_daochu" + params)
    //             vm.$Modal.remove()
    //           } else {
    //             vm.$Message.error(res.errorMsg)
    //           }
    //         })
    //     }
    //   }
    //   this.$Modal.confirm(config)

    // },
    export(row) {
      let vm = this;
      let config = {
        loading: true,
        width: 600,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "15px" } },
                  this.$t("dictmenu.suredelete")
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer",
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove();
                    },
                  },
                }),
              ]
            ),
            h(downloadHistory, {
              ref: "downloadHistory",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: true,
                projectCode: this.code,
                dids: this.dids,
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.downloadHistory;
          obj.checkForm().then((req) => {
            if (req) {
              let formModel = obj.formModel;
              let domain = vm.get_domain();

              //提交请求
              // console.log("formModel",formModel)
              // return;
              get_downloadtoken().then((res) => {
                _this.buttonLoading = false;
                if (res.result === 0) {
                  let downloadtoken = res.body.downloadtoken;
                  let params =
                    "?type=1&downloadtoken=" +
                    downloadtoken +
                    "&did=" +
                    row.did +
                    "&time_start=" +
                    formModel.start_time +
                    "&time_end=" +
                    formModel.end_time;

                  window.open(
                    domain + "/index.php/admin/device/history_daochu" + params
                  );
                  vm.$Modal.remove();
                } else {
                  vm.$Message.error(res.errorMsg);
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    get_domain() {
      let result = "";
      if (process.env.NODE_ENV === "development") {
        result = config.baseUrl.dev;
      } else if (process.env.VUE_APP_BUILD === "production") {
        result = config.baseUrl.pro;
      } else {
        result = config.baseUrl.alp;
      }
      return result;
    },
    pl_distribution(row) {
      let vm = this;
      let config = {
        loading: true,
        width: 600,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "15px" } },
                  this.$t("devicelist.mostfenpei")
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer",
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove();
                    },
                  },
                }),
              ]
            ),
            h(addAppCustom, {
              ref: "addAppCustom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: true,
                projectCode: this.code,
                dids: this.dids,
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.addAppCustom;
          obj.checkForm().then((req) => {
            if (req) {
              //提交请求
              debugger;
              let formModel = obj.formModel;
              //formData.append('filename',formModel.filename)
              let formData = new FormData();
              vm.formModelGlobe = formModel;
              //formData['filename'] = formModel.filename
              //formData['merchant_code'] = formModel.merchant_code
              //formData['dids']=formModel.dids

              //return;
              //formData=formModel
              formData.append("filename", formModel.filename);
              for (var i = 0; i < formModel.merchant_code.length; i++) {
                formData.append(
                  "merchant_code[" + i + "]",
                  formModel.merchant_code[i]
                );
              }

              for (var i = 0; i < formModel.dids.length; i++) {
                formData.set("dids[" + i + "]", formModel.dids[i]);
              }
              allocation_add(formData).then((res) => {
                console.log("WOJIsadas0", formData);
                if (res.result === 0) {
                  vm.$Message.success(res.errorMsg);
                  vm.$Modal.remove();
                  this.dids = [];
                  vm.init();
                } else {
                  if (res.result === 300) {
                    console.log("WOJIsadas1", formData.get("filename"));
                    // let formData = new FormData();
                    // formData.append("filename", formModel.filename);
                    // formData.append("model_code", formModel.model_code);
                    vm.formData1 = formData.get("filename");
                    vm.dataValue = res.body;
                    vm.dataText = res.errorMsg;
                    vm.showImg1 = true;
                    //  _this.buttonLoading = false;
                    // vm.$Modal.remove();

                    //   vm.$Modal.info({
                    //     title: "提示",
                    //     content: `<div>
                    //   <p>错误信息: ${dataText}</p>
                    //   <p>详细数据: ${JSON.stringify(dataValue)}</p>
                    // </div>`,
                    //     onOk() {
                    //       // 用户点击确定后的逻辑
                    //     },
                    //     zIndex: 9999,
                    //   });
                  }
                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    okData() {
      let vm = this;
      console.log("WOJIsadas");
      let fd = new FormData();
      fd.append("is_confirm", 1);
      console.log("formModelGlobe", this.formModelGlobe);
      fd.append("filename", this.formModelGlobe.filename);
      for (var i = 0; i < this.formModelGlobe.merchant_code.length; i++) {
        fd.append(
          "merchant_code[" + i + "]",
          this.formModelGlobe.merchant_code[i]
        );
      }

      for (var i = 0; i < this.formModelGlobe.dids.length; i++) {
        fd.append("dids[" + i + "]", this.formModelGlobe.dids[i]);
      }
      fd.append("is_confirm", 1);
      // this.formData1.is_confirm = 1;
      // vm.formData1.append('allocation_add',1)
      debugger;
      allocation_add(fd).then((res) => {
        console.log("WOJIsadas222", res, vm.formData1);
        vm.$Message.success(res.errorMsg);
        vm.$Modal.remove();
      });
    },
    didSelectChange(SelectItem) {
      this.dids.splice(0);
      if (SelectItem && SelectItem.length > 0) {
        for (let i in SelectItem) {
          let list = SelectItem[i];
          this.dids.push(list.did);
          // this.ids = list.id
        }
      }
      console.log(this.dids);
    },

    quxiao_distribution(row) {
      let vm = this;
      let config = {
        loading: true,
        title: this.$t("devicelist.cancelfenpei"),
        content: this.$t("devicelist.quedingcancel") + row.did,
        onOk: function () {
          let _this = this;
          quxiao_fenpei({ id: row.id,}).then((res) => {
            if (res.result === 0) {
              vm.$Message.success(res.errorMsg);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(res.errorMsg);
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    distribution(row) {
      let vm = this;
      let config = {
        loading: true,
        width: 800,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "15px" } },
                  row.did + this.$t("devicelist.fenpei")
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer",
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove();
                    },
                  },
                }),
              ]
            ),
            h(addAppCustom, {
              ref: "addAppCustom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: true,
                projectCode: this.code,
                setData: row,
              },
            }),
          ]);
        },
        onOk: function () {
          debugger;
          let obj = this.$refs.addAppCustom;
          obj.checkForm().then((req) => {
            if (req) {
              //提交请求
              let formModelVal = obj.formModel;
              allocation_add({ ...formModelVal }).then((res) => {
                if (res.result === 0) {
                  vm.$Message.success(res.errorMsg);
                  vm.$Modal.remove();
                  this.dids = [];
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg);
                  this.buttonLoading = false;
                }
              });
            } else {
              this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    init() {
      localStorage.setItem('country_code',this.form_filter.country_code)
      let userinfo = this.getUser();
      this.pass_priv = userinfo.pass_priv;

      this.getMerchantData();
      this.tableLoading = true;
      device_distribution_list({ ...this.reqBase }).then((res) => {
        this.tableLoading = false;
        this.tableDataList = [];
        if (res.result === 0) {
          this.tableDataList = res.body.list || [];
          console.log("this.tableDataList", this.tableDataList);

          this.getPageTotal = res.body.total;
        } else {
          this.tableDataList = [];
          this.getPageTotal = 0;
          this.$Message.error(res.errorMsg);
        }
      });
    },
    //新增
    // add() {
    //   let vm = this;
    //   let config = {
    //     loading: true,
    //     width: 800,
    //     render: (h) => {
    //       return h('div', [
    //         h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
    //           h('h3', { style: { width: '100%', paddingBottom: '5px' } }, '添加'),
    //           h('icon', {
    //             props: { type: 'md-close', size: '16' },
    //             style: {
    //               cursor: 'pointer'
    //             },
    //             on: {
    //               'click': evt => {
    //                 vm.$Modal.remove()
    //               }
    //             }
    //           })
    //         ]),
    //         h('Divider',{
    //           style:{
    //             margin:'8px 0'
    //           }
    //         }),
    //         h(addAppCustom, {
    //           ref: 'addAppCustom',
    //           props: {
    //             _vm: vm,
    //             $store:vm.$store,
    //             edit:false,
    //             projectCode:this.code
    //           }
    //         })
    //       ])
    //     },
    //     onOk: function () {
    //       let _this = this;
    //       let obj = this.$refs.addAppCustom;
    //       obj.checkForm().then(res => {
    //         if (res) {
    //           //提交请求
    //           let formModel = obj.formModel;
    //           building_add(formModel).then(res => {
    //             let msg=res.errorMsg;
    //             if (res.result === 0) {
    //               let msg=res.errorMsg;
    //               vm.$Message.success(msg);
    //               vm.$Modal.remove();
    //               vm.init();
    //             } else {
    //               vm.$Message.error(msg);
    //               _this.buttonLoading = false;
    //             }
    //           });
    //         } else {
    //           _this.buttonLoading = false;
    //         }
    //       });
    //     }
    //   };
    //   this.$Modal.confirm(config);
    // },
    getMerchantData() {
      console.log(111);
      this.merchantData.splice(0);
      get_merchant_all().then((res) => {
        if (res.result === 0) {
          console.log(data);
          let data = res.body;
          this.checkTree(data);
          // console.log('a',data)
          this.merchantData = data;
        }
      });
    },
    checkTree(arr) {
      for (let i in arr) {
        if (arr[i].shop_name) {
          arr[i].value = arr[i].merchant_code;
          arr[i].label = arr[i].shop_name;
          arr[i].title = arr[i].shop_name;
        } else if (arr[i].shop_name) {
          arr[i].title = arr[i].shop_name;
        }
        if (arr[i].children_shop && arr[i].children_shop.length > 0) {
          arr[i].children.push(...arr[i].children_shop);
        }
        if (arr[i].children && arr[i].children.length > 0) {
          this.checkTree(arr[i].children);
        }
      }
    },
    search() {
      this.onSearch(this.form_filter);
    },
    reset() {
      this.form_filter = {
        model_code: "",
        sw_ver: "",
        merchant_code: [],
        fp_status: -1,
        did: "",
        status: -1,
        project_id: null,
        hw_ver: null,
        sw_ver: null,
        sw_channel: 1,
        bms_sn: null,
        pack_sn: null,
        country_code: "xciot-prod-cnsz",
      };
      this.search();
    },
    control(row) {
      const routeData = this.$router.push({
        path: "/deviceman/control",
        query: { did: row.did },
      });
      window.open(routeData.href, "_self");
    },
    details(row) {
      console.log("rowrowrowrow", row.class_codes);
      if (row.class_codes.includes("SCLI")) {
        console.log("rowrowrowrow", 1);
        const routeData = this.$router.push({
          path: "/deviceman/detailsSCLI",
          query: { did: row.did },
        });
        window.open(routeData.href, "_self");
      } else {
        console.log("rowrowrowrow", 2);
        if (row.model_code == "GBMSMT") {
          const routeData = this.$router.push({
            // path: "/deviceman/detailsNew",detailsNbc,detailsSCLI
            path: "/deviceman/detailsNew",
            query: { did: row.did },
          });
          window.open(routeData.href, "_self");
        } else {
          if (row.device_type == 1) {
            const routeData = this.$router.push({
              path: "/deviceman/details",
              query: { did: row.did },
            });
            window.open(routeData.href, "_self");
          } else if (row.device_type == 2) {
            // localStorage.setItem('rowData', JSON.stringify(row));
            const routeData = this.$router.push({
              path: "/deviceman/detailsdy",
              query: { did: row.did },
            });
            window.open(routeData.href, "_self");
          } else if (row.device_type == 3) {
            const routeData = this.$router.push({
              path: "/deviceman/detailscc",
              query: { did: row.did },
            });
            window.open(routeData.href, "_self");
          }
        }
      }
    },
    trajectory(row) {
      const routeData = this.$router.push({
        path: "/trajectory",
        query: { did: row.did },
      });
      window.open(routeData.href, "_self");
    },
    // details(row){
    //   let vm = this;
    //   let config = {
    //     loading: true,
    //     width: 800,
    //     okText:'关闭',
    //     render: (h) => {
    //       return h('div', [
    //         h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
    //           h('h3', { style: { width: '100%', paddingBottom: '15px' } }, '详情'),
    //           h('icon', {
    //             props: { type: 'md-close', size: '16' },
    //             style: {
    //               cursor: 'pointer'
    //             },
    //             on: {
    //               'click': evt => {
    //                 vm.$Modal.remove()
    //               }
    //             }
    //           })
    //         ]),
    //         h(customDetails, {
    //           ref: 'customDetails',
    //           props: {
    //             _vm: vm,
    //             $store:vm.$store,
    //             edit:true,
    //             setData: row
    //           }
    //         })
    //       ])
    //     },
    //     onOk: function () {
    //       vm.$Modal.remove();
    //     }
    //   };
    //   this.$Modal.success(config);
    // },
    edit(row) {
      let vm = this;
      let config = {
        loading: true,
        width: 800,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "15px" } },
                  "分配经销商"
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer",
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove();
                    },
                  },
                }),
              ]
            ),
            h(addAppCustom, {
              ref: "addAppCustom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: true,
                projectCode: this.code,
                setData: row,
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.addAppCustom;
          obj.checkForm().then((req) => {
            if (req) {
              //提交请求
              let formModel = obj.formModel;
              allocation_add({ ...formModel }).then((res) => {
                if (res.result === 0) {
                  vm.$Message.success(res.errorMsg);
                  vm.$Modal.remove();
                  this.dids = [];
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    del(row) {
      let vm = this;
      let config = {
        loading: true,
        title: "删除",
        content: "您确定要删除序号为 " + row.id + " 的数据吗",
        onOk: function () {
          let _this = this;
          allocation_del({ allocation_code: row.allocation_code }).then(
            (res) => {
              if (res.result === 0) {
                vm.$Message.success(res.errorMsg);
                vm.$Modal.remove();
                vm.init();
              } else {
                vm.$Message.error(res.errorMsg);
                _this.buttonLoading = false;
              }
            }
          );
        },
      };
      this.$Modal.confirm(config);
    },
  },
  mounted() {
    let query = this.$route.query;
    if (query && query.hasOwnProperty("status")) {
      this.$set(this.form_filter, "status", parseInt(query.status));
    }
    if (this.code) {
      this.$set(this.reqBase, "project_code", this.code);
    }
    if (this.reducehe) {
      this.reduceheight = this.reducehe;
    } else {
      this.search();
    }

    // this.$set(this,'columnsheader',baseColumns)
    console.log("this.columnsheader", this.columnsheader.length);
  },
  created() {
    this.columnsheader = [
      // {
      //   align: "center",
      //   title: "序号",
      //   width: 60,
      //   key: "did",
      //   type: "selection",
      //   // _disabled:true
      // },
      {
        align: "center",
        title: this.$t("productImg"),
        width: 100,
        key: "pic",
        render: (h, { row }) => {
          return h(
            "div",
            {
              on: {
                click: () => {
                  this.showImgUrl = row.pic;
                  this.showImg = true;
                },
              },
            },
            [
              h("Avatar", {
                style: {
                  cursor: "pointer",
                },
                props: {
                  src: row.pic,
                },
              }),
            ]
          );
        },
      },
      {
        align: "center",
        title: this.$t("devicelist.modelcode"),
        minWidth: 120,
        key: "model_code",
      },
      {
        align: "center",
        title: this.$t("devicelist.did"),
        minWidth: 120,
        width: 250,
        key: "did",
        render: (h, { row }) => {
          return h(
            "span",
            {
              style: {
                color: "#2d8cf0",
                "text-decoration": "underline",
                cursor: "pointer",
              },
              on: {
                click: () => {
                  this.details(row);
                },
              },
            },
            row.did
          );
        },
      },
      {
        align: "center",
        title: this.$t("devicelist.status"),
        minWidth: 120,
        key: "status",
        render: (h, { row }) => {
          let result = "";
          let color = "";
          if (row.status === 1) {
            color = "error";
            result = this.$t("devicelist.offline");
          } else if (row.status === 2) {
            color = "success";
            result = this.$t("devicelist.online");
          } else {
            color = "primary";
            result = this.$t("devicelist.notknow");
          }
          return h(
            "Tag",
            {
              props: {
                color,
              },
            },
            result
          );
        },
      },
      {
        align: "center",
        title: "SN",
        minWidth: 120,
        key: "sn",
      },

      {
        align: "center",
        title: this.$t("devicelist.projectnum"),
        minWidth: 120,
        key: "project_id",
      },
      {
        align: "center",
        title: this.$t("devicelist.hardwareversionnumber"),
        minWidth: 120,
        key: "hw_ver",
      },
      {
        align: "center",
        title: this.$t("devicelist.softwareversionnumber"),
        minWidth: 100,
        key: "sw_ver",
      },
      {
        align: "center",
        title: this.$t("devicelist.agent"),
        minWidth: 120,
        key: "shop_name",
      },
      {
        align: "center",
        title: this.$t("devicelist.lastonlinetime"),
        minWidth: 120,
        key: "last_online_time",
      },
      {
        align: "center",
        title: "bms_sn",
        minWidth: 120,
        key: "bms_sn",
      },
      {
        align: "center",
        title: "pack_sn",
        minWidth: 120,
        key: "pack_sn",
      },
      {
        align: "center",
        title: this.$t("devicelist.activationtime"),
        minWidth: 120,
        key: "activation_time",
      },
      {
        align: "center",
        title: this.$t("operation"),
        minWidth: 120,
        fixed: "right",
        key: "Operating",
        render: (h, { row }) => {
          if (1) {
            let arr = [];
            for (let i in this.operationButtonList) {
              if (row.fp_did == "" && i == 0) {
                //去分配
                let list = this.operationButtonList[i];
                arr.push(
                  h(
                    "Button",
                    {
                      style: {
                        marginLeft: "5px",
                        marginBottom: "3px",
                        color: "#2d8cf0",
                      },
                      props: {
                        type: list.type,
                        size: list.size ? list.size : "small",
                      },
                      on: {
                        click: () => {
                          list.method(row);
                        },
                      },
                    },
                    list.name
                  )
                );
              } else {
                if (row.fp_did != "" && i == 1) {
                  //取消分配
                  let list = this.operationButtonList[i];
                  arr.push(
                    h(
                      "Button",
                      {
                        style: {
                          marginLeft: "5px",
                          marginBottom: "3px",
                          color: "#2d8cf0",
                        },
                        props: {
                          type: list.type,
                          size: list.size ? list.size : "small",
                        },
                        on: {
                          click: () => {
                            list.method(row);
                          },
                        },
                      },
                      list.name
                    )
                  );
                }
              }
            }

            return h("div", arr);
          }
        },
      },
    ];

    // 沛城平台账号 产测时间和产测状态
    if (localStorage.getItem("is_dingji") == 1) {
      this.columnsheader.push(
        {
          align: "center",
          title: this.$t("devicelist.cctime"),
          minWidth: 120,
          key: "cctime",
        },
        {
          align: "center",
          title: this.$t("devicelist.ccstatus"),
          minWidth: 120,
          key: "ccstatus",
        }
      );
    }
  },
};
</script>
<style scoped>
.div2 {
  font-size: 15px;
  text-align: center;
}

.contentBaseRef /deep/ .headerWrapper {
  align-items: center;
}

.handle_operation {
  /* float: right;
    margin-right: 50px;
    margin-top: -39px; */
}

form {
  padding: 10px;
}

.packageTable /deep/ .ivu-table-fixed,
.packageTable /deep/ .ivu-table-fixed-right {
  top: 0px !important;
  align-items: center;
}
</style>
